import React        from 'react';
import { Redirect } from 'react-router-dom';
import Lesson       from './Lesson';
import LessonList   from './LessonList';

export const LessonConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path      : '/lesson/:view_type/:lesson_id/:course_id',
            component : Lesson,
            permission: { component_name: 'lesson', permission_type: 'view_type' },
        },
        {
            path      : '/lesson/:view_type/:lesson_id',
            component : Lesson,
            permission: { component_name: 'lesson', permission_type: 'view_type' },
        },
        {
            path      : '/lesson/list',
            component : LessonList,
            permission: { component_name: 'lesson', permission_type: 'list' },
        },
        {
            path      : '/lesson/:view_type/',
            component : Lesson,
            permission: { component_name: 'lesson', permission_type: 'view_type' },
        },
        {
            path      : '/lesson',
            component : () => <Redirect to="/lesson/list" />,
            permission: { component_name: 'lesson', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/lesson/LessonConfig.js